import * as React from 'react';
import Box from '@mui/material/Box';
import {
  Avatar,
  Stack,
  Grid,
  Button,
  TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  FormHelperText,
  Typography,
} from '@mui/material';
import {useState, useEffect, useContext} from 'react';
import FileUploader from '../upload/FileUploader';
import SendIcon from '@mui/icons-material/Send';
import textInputValidator from '../event/EventValidator';
import {Actuality} from '../actuality/queries/Actuality';
import PublishHeader from './PublishHeader';
import AlertDialog from './AlertDialog';
import {useUserInfo} from '../userInfo/hooks/useUserInfo';
import axios from '../../axios';
import {useUserCommunities} from '../community/hooks/useUserCommunities';
import {useDarkMode} from '../darkMode/hook/useDarkMode';
import {useNewsFeed} from '../newsFeed/hooks/useNewsFeed';
import AvatarProfile from '../dashboard/AvatarProfile';
import InputAdornment from '@mui/material/InputAdornment';
import WiswigEditor from '../editor/Wiswig';

const PostActuality = ({setScreenToShow, updateActualities}) => {
  const [image, setImage] = useState([]);
  const [communityIsError, setCommunityIsError] = useState(false);
  const [titleIsError, setTitleIsError] = useState(false);
  const [titleHelperText, setTitleHelperText] = useState(' ');
  const [detailIsError, setDetailIsError] = useState(false);
  const [detailHelperText, setDetailHelperText] = useState(' ');
  const [labelImage, setLabelImage] = useState('+ Ajouter une image');
  const [actualityTitle, setActualityTitle] = useState('');
  const [actualityDetail, setActualityDetail] = useState('');
  const [communityId, setCommunityId] = useState('');
  const [communityHelperText, setCommunityHelperText] = useState(' ');
  const [isLoading, setIsLoading] = React.useState(false);
  const [imageError, setImageError] = useState(false);
  const [open, setOpen] = React.useState(false);
  const {profil} = useUserInfo();
  const {list} = useUserCommunities();
  const [needToReset, setNeedToReset] = useState(false);
  const handleClickOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };
  const {reload} = useNewsFeed();

  const handleSubmit = event => {
    event.preventDefault();
    const errorCommunity = textInputValidator(
      communityId,
      setCommunityIsError,
      setCommunityHelperText,
    );
    const errorTitle = textInputValidator(actualityTitle, setTitleIsError, setTitleHelperText, 50);
    const errorDetail = textInputValidator(actualityDetail, setDetailIsError, setDetailHelperText);
    console.log(errorDetail, actualityDetail);
    if (image.length === 0) {
        setImageError(true);
    } else {
        setImageError(false);
    }
    if (
      !errorCommunity &&
      !errorTitle &&
      !errorDetail &&
      image.length > 0
    ) {
      handleClickOpen();
    }
  };

  const resetSelect = () => {
    setCommunityId('');
  };

  const {mode} = useDarkMode();

  const handleAccept = () => {
    const [photo] = image;
    setIsLoading(true);
    Actuality.sendActuality(actualityTitle, actualityDetail, photo, communityId)
      .then(response => {
        if (response === 201) {
          setActualityTitle('');
          setActualityDetail('');
          setNeedToReset(true);
          setImage([]);
          setLabelImage('+ Ajouter image');
          setIsLoading(false);
          handleClose();
          reload();
          resetSelect();
          if (updateActualities) {
            updateActualities();
          }
        }
      })
      .catch(() => {
        setIsLoading(false);
      });
  };

  return (
    <Box
      component="form"
      onSubmit={handleSubmit}
      sx={{borderRadius: 1, padding: {xs : '20px',md : '20px',lg : '20px'}}}
      style={{backgroundColor: mode.settings.cardBackgroundColor}}>
      <AlertDialog
        handleAccept={handleAccept}
        handleClose={handleClose}
        text={'Voulez-vous vraiment publier cette actualité ?'}
        open={open}
        isLoading={isLoading}></AlertDialog>
      <Stack spacing={1}>
        <PublishHeader
          categorActive={'ACTUALITY'}
          setScreenToShow={setScreenToShow}
        />
        <Stack direction={'row'} spacing={{xs : 0, md : 0, lg : 2}} flexWrap={'nowrap'}>
          <Grid item xs={3} sx={{display : {xs : 'none', md : 'none', lg : 'block'}}}>
            {profil && <AvatarProfile size={69} showName={false} />}
          </Grid>
          <Stack direction={'column'} flexGrow={'inherit'}>
            <TextField
              value={actualityTitle}
              error={titleIsError}
              label="Ajouter un titre"
              variant="filled"
              onChange={event => setActualityTitle(event.target.value)}
              sx={{background: mode.settings.inputBackgroundColor}}
              InputProps={{
                inputProps: {style: {color: mode.settings.textColor3}},
              }}
              InputLabelProps={{style: {color: mode.settings.textColor3}}}
            />
            {
                titleIsError &&
                <Typography variant={'subtitle4'} color={'#d32f2f'} sx={{marginTop : '5px'}}>{titleHelperText}</Typography>
            }
            <br />
            <div className="mb-4">
              <WiswigEditor onChange={setActualityDetail} reset={needToReset} placeholder={'Ajouter du contenu'} detailIsError={detailIsError}/>
            </div>
            {
                detailIsError &&
                <Typography variant={'subtitle4'} color={'#d32f2f'} sx={{marginTop : '5px'}}>Ce champ est obligatoire.</Typography>
            }
            <Stack
              direction="row"
              gap={2}
              alignItems="center"
              justifyContent="space-between"
              alignContent="center"
              marginTop={'10px'}
              flexWrap={'wrap'}
            >
              <Box>
                <Stack
                  direction="row"
                  justifyContent="left"
                  alignItems="center">
                  <FileUploader
                    setImageToUpload={setImage}
                    setLabelImage={setLabelImage}
                    labelImage={labelImage}
                    onError={imageError}
                    setImageError={setImageError}
                  >
                  </FileUploader>
                </Stack>
              </Box>
              <Box flexGrow={1} sx={{minWidth : '330px'}}>
                <FormControl
                  fullWidth
                  error={communityIsError}
                  variant="standard">
                  <InputLabel
                    id="demo-simple-select-label"
                    sx={{color: mode.settings.textColor3, fontSize : {xs : 15, md : 18, lg : 18}}}>
                    Choisissez la communauté correspondante
                  </InputLabel>
                  <Select
                    value={communityId}
                    label="Age"
                    onChange={event => {
                      setCommunityId(event.target.value);
                    }}
                    sx={{
                      height: '49px',
                      color: mode.settings.textColor3,
                      '& .MuiSelect-select': {paddingLeft: '10px'},
                    }}
                    MenuProps={{
                      PaperProps: {
                        style: {
                          backgroundColor: mode.darkMode ? '#242526' : 'white',
                          color: mode.settings.textColor3,
                        },
                      },
                    }}
                    aria-label={'Choisir une communauté'}>
                    {list &&
                      list.map((option, index) => (
                        <MenuItem key={index} value={option.id}>
                          {option.name.text}
                        </MenuItem>
                      ))}
                  </Select>
                  <FormHelperText>{communityHelperText}</FormHelperText>
                </FormControl>
              </Box>
              <Box width={{xs : '100%', md : '25%', lg : '20%'}}>
                <Stack
                  direction="row"
                  justifyContent="right"
                  alignItems="center"
                  spacing={1}
                  width={{xs : '100%'}}
                >
                  <Button
                    className="buttonPublish"
                    startIcon={
                      <SendIcon role="img" aria-label={"Publier l'actualité"} />
                    }
                    sx={{paddingLeft: 15, width : {xs : '100%'}}}
                    type="submit">
                    <Typography variant={'subtitle3'}>Publier</Typography>
                  </Button>
                </Stack>
              </Box>
            </Stack>
          </Stack>
        </Stack>
      </Stack>
    </Box>
  );
};

export default PostActuality;
